import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/store/modules/auth'

const routes = [

//  {
//     path: '/',
//     redirect:'/login_pages/signup'
//   },
  {
    path:"/error/504",
    component: () => import('@/views/error/NotFound.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false },
    props:{
      message:"잘못된 접근입니다",
      bgimage:"bg_error_page"
    }
  },
  {
    path:"/:pathMatch(.*)*",
    component: () => import('@/views/error/NotFound.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false },
    props:{
      message:"페이지를 찾을 수 없습니다",
      bgimage:"bg_error_404"
    }
  },
  {
    path: '/join',
    component: () => import('@/views/auth/JoinLayout.vue'), // 가입 전체를 감싸는 껍데기
    redirect: '/join/type',
    children: [
        { path: 'type', component: () => import('@/views/auth/JoinType.vue'), meta: { title: '회원가입', headerType: 'subB', requiresConfirm: true } }, // 출입증 발급 페이지
        { path: 'terms', component: () => import('@/views/auth/StepTerms.vue'), meta: { title: '약관동의', headerType: 'subB', requiresConfirm: true } }, // 약관동의 페이지
        { path: 'authhority', component: () => import('@/views/auth/Authhority.vue'), meta: { title: '권한안내', headerType: 'subB', requiresConfirm: true,  } },   // 본인인증 관련 페이지
        { path: 'auth', component: () => import('@/views/auth/StepAuth.vue'), meta: { title: '본인인증', headerType: 'subB', requiresConfirm: true,  } },   // 본인인증 관련 페이지
        { path: 'card', component: () => import('@/views/auth/AuthCard.vue'), meta: { title: '사용자 확인', headerType: 'subB', requiresConfirm: true } },    // 인증 완료 후 사용자 확인
        { path: 'pass', component: () => import('@/views/auth/LoginPass.vue'), meta: { title: '간편 비밀번호 입력', headerType: 'subB', requiresConfirm: true } },  // 간편비밀번호 입력
        { path: 'passReg', component: () => import('@/views/auth/PassReg.vue'), meta: { title: '이용안내', headerType: 'subB1', requiresConfirm: true } },   // 간편 비밀번호 입력 완료
        { path: 'simpleLogin', component: () => import('@/views/auth/SimpleLogin.vue'), meta: { title: '간편 인증 등록', headerType: 'subB1', requiresConfirm: true } }, // 간편인증 추가 등록 안내 페이지
        { path: 'complete', component: () => import('@/views/auth/Complete.vue'), meta: { title: '', headerType: 'subC', requiresConfirm: true } },   // 출입증 발급완료
    ]

  },
  {
    path: '/login_pages',
    component: () => import('@/views/login/LoginLayout.vue'), // 로그인관련 페이지
    redirect: '/login_pages/type',
    children: [
        { path: 'type', component: () => import('@/views/login/LoginType.vue'), meta: { title: '', headerType: 'subC', requiresConfirm: true } }, // 간편비밀번호 로그인 및 로그인 변경관련 페이지
        { path: 'pass', component: () => import('@/views/login/LoginPass.vue'), meta: { title: '간편 비밀번호 입력', headerType: 'subB', requiresConfirm: true } },  // 간편인증 등록시 간편비밀번호 확인
        { path: 'signup', component: () => import('@/views/login/SignUp.vue'), meta: { title: '이용안내', headerType: 'subB1', requiresConfirm: true } },   // QR 신규 발급
    ]
  },
  {
    path: '/support',
    component: () => import('@/views/support/SupportLayout.vue'), // 설정 및 공지사항 관련 페이지
    redirect: '/support/loginSetting',
    children: [
        { path: 'loginSetting', component: () => import('@/views/support/SettingLogin.vue'), meta: { title: '로그인 설정', headerType: 'subE', requiresConfirm: true } },
        { path: 'accessAuth', component: () => import('@/views/support/AccessAuth.vue'), meta: { title: '출입 인증 수단 설정', headerType: 'subB', requiresConfirm: true } },
        { path: 'noticeList', component: () => import('@/views/support/NoticeList.vue'), meta: { title: '공지사항', headerType: 'subE', requiresConfirm: true } },
        { path: 'noticeView', name:'noticeView', component: () => import('@/views/support/NoticeView.vue'), meta: { title: '공지사항', headerType: 'subB', requiresConfirm: true } },
        { path: 'faq', component: () => import('@/views/support/Faq.vue'), meta: { title: 'FAQ', headerType: 'subE', requiresConfirm: true } },
        { path: 'info', component: () => import('@/views/support/Info.vue'), meta: { title: '정보', headerType: 'subB', requiresConfirm: true } },
        { path: 'menu', component: () => import('@/views/support/Menu.vue'), meta: { title: '전체메뉴', headerType: 'subB', requiresConfirm: true } },
        { path: 'terms', component: () => import('@/views/support/Terms.vue'), meta: { title: '이용약관', headerType: 'subB', requiresConfirm: true } },
      
    ]
  },
  {
    path: '/access',
    component: () => import('@/views/access/AccessLayout.vue'), // 출입관리 페이지
    redirect: '/access/accessList',
    children: [
        { path: 'accessList', component: () => import('@/views/access/AccessList.vue'), meta: { title: '출입 신청 목록', headerType: 'subB', requiresConfirm: true } },
        { path: 'accessView', name:'accessView',  component: () => import('@/views/access/AccessView.vue'), meta: { title: '출입 신청 정보', headerType: 'subB', requiresConfirm: true } },
        { path: 'accessForm', component: () => import('@/views/access/AccessForm.vue'), meta: { title: '출입 신청', headerType: 'subB', requiresConfirm: true } },
        { path: 'complete', component: () => import('@/views/access/AccessComplete.vue'), meta: { title: '출입 신청', headerType: 'subB', requiresConfirm: true } },
    ]
  },
  {
    path: '/visitQr/:text',
    // component: () => import('@/views/landing/LandingLayout.vue'),
    component: () => import('@/views/landing/VisitQr.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false }
    // children: [
    //     { path: 'visitQr/:text', component: () => import('@/views/landing/VisitQr.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false } },
    // ]
  },
  {
    path: '/entdownload/link',
    component: () => import('@/views/landing/AppDown.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false }


  },
  {
    path: '/information',
    component: () => import('@/views/landing/Information.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false }
  },
  {
    path: '/entdownload',
    component: () => import('@/views/landing/AppGuide.vue'), meta: { title: '', headerType: 'none', requiresConfirm: false  }
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: LoginView
  // },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: HomeView
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// // 라우터 네비게이션 가드
// router.beforeEach((to, from, next) => {
//   // 스토어에서 로그인 상태 가져오기
//   const authStore = useAuthStore();
//   const isLoggedIn = authStore.isLoggedIn;

//   if (to.path === '/login' && isLoggedIn) {
//     // 이미 로그인된 상태에서 로그인 페이지 접근 시 홈으로 리다이렉트
//     next('/home');
//   // } else if (to.path !== '/login' && to.path !== '/changeDevice' && !to.path.startsWith('/join') && !isLoggedIn) {
//   //   // 로그인되지 않은 상태에서 보호된 페이지 접근 시 로그인으로 리다이렉트
//   //   next('/login');
//   // 
//   } else {
//     // 그 외는 정상 이동
//     next();
//   }
// });

export default router
